export default {
  evaluationsTitle: 'Evaluaciones:',
  evaluationsPrintTitle: 'Evaluaciones - {code} {name}',
  evaluations: 'Evaluaciones',
  evaluationXLSX: 'Evaluación XLSX',
  evaluationType: 'Tipo de evaluación',
  learningOutcome: 'Resultado de aprendizaje',
  achievementIndicators: 'Indicadores de Logro',
  evaluativeSituation: 'Situación evaluativa',
  authenticEvaluation: 'Evaluación Auténtica',
  evaluationDescription: 'Descripción evaluación',
  evaluationDescriptionTooltip: 'Descripción evaluación (Mencionar las características principales que configuran la actividad de evaluación: características principales del encargo, ejecución práctica, pruebas escritas o presentación)',
  connectionWithEnvironment: 'Vinculación con el Medio',
  evaluativeAgent: 'Agente evaluativo',
  evaluationWeighting: 'Ponderación evaluación',
  weightingByEvaluativeSituation: 'Ponderación por situación evaluativa',
  directedTeachingHours: 'Horas de Docencia Dirigida (pedagógicas)',
  autonomousWorkHours: 'Horas de Trabajo Autónomo Preparación y/o Ejecución (cronológicas)',
  workType: 'Tipo de trabajo',
  environment: 'Ambiente',
  examiner: 'Examinador/a',
  avaLiberationWeek: 'Semana Liberación AVA',
  hrs: 'Hrs.',
}
